var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _path30, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _g2, _g3, _rect74, _g4, _g5, _rect75, _g6, _g7, _rect76, _g8, _g9, _path31, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle, _path39, _circle2, _path40, _circle3, _path41, _circle4, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle5, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle6, _path57, _circle7, _path58, _path59, _path60, _circle8, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g0, _g1, _rect77, _path145, _g10, _path146, _g11, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _polygon15, _g12, _g13, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceOfficers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e27227;}.cls-2{fill:#17282f;}.cls-3{fill:#4c73c0;}.cls-4{fill:#1a2e35;}.cls-5{fill:#d46b26;}.cls-6{fill:#fd802e;}.cls-7{fill:#fff;}.cls-8{fill:#dde9ff;}.cls-9{fill:#bcbcbc;}.cls-10{fill:#ffc800;}.cls-11{fill:#fbc6b4;}.cls-12{opacity:.45;}.cls-13{opacity:.5;}.cls-14{opacity:.1;}.cls-15{fill:#ee7524;}.cls-16{fill:#85b8e6;}.cls-17{fill:#a8a8a8;}.cls-18{fill:#ffb62d;}.cls-19{fill:#dcdcdc;}.cls-20{fill:#ececec;}.cls-21{fill:#c8c8c8;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 286.38,
    y: 7.74,
    width: 148.38,
    height: 116.96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 291.49,
    y: 12.34,
    width: 138.16,
    height: 107.77
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 329.57,
    y: 23.6,
    width: 62.01,
    height: 1.37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 340.17,
    y: 26.47,
    width: 40.8,
    height: 1.37
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 311.93,
    y: 108.72,
    width: 4.27,
    height: 4.27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 319.16,
    y: 108.72,
    width: 46.71,
    height: 1.26
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 319.16,
    y: 111.73,
    width: 30.19,
    height: 1.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.69,43.15c16.96-.13,33.92-.1,50.88-.15,16.96.05,33.92.02,50.88.15-16.96.13-33.92.1-50.88.15-16.96-.05-33.92-.02-50.88-.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.69,55.31c16.96-.13,33.92-.1,50.88-.15,16.96.05,33.92.02,50.88.15-16.96.13-33.92.1-50.88.15-16.96-.05-33.92-.02-50.88-.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.69,67.46c16.96-.13,33.92-.1,50.88-.15,16.96.05,33.92.02,50.88.15-16.96.13-33.92.1-50.88.15-16.96-.05-33.92-.02-50.88-.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.69,79.62c16.96-.13,33.92-.1,50.88-.15,16.96.05,33.92.02,50.88.15-16.96.13-33.92.1-50.88.15-16.96-.05-33.92-.02-50.88-.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.69,91.77c16.96-.13,33.92-.1,50.88-.15,16.96.05,33.92.02,50.88.15-16.96.13-33.92.1-50.88.15-16.96-.05-33.92-.02-50.88-.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M330.18,35.25c.15,11.36.11,22.72.17,34.07-.06,11.36-.02,22.72-.17,34.07-.15-11.36-.11-22.72-.17-34.07.06-11.36.02-22.72.17-34.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M347.78,35.25c.15,11.36.11,22.72.17,34.07-.06,11.36-.02,22.72-.17,34.07-.15-11.36-.11-22.72-.17-34.07.06-11.36.02-22.72.17-34.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M365.37,35.25c.15,11.36.11,22.72.17,34.07-.06,11.36-.02,22.72-.17,34.07-.15-11.36-.11-22.72-.17-34.07.06-11.36.02-22.72.17-34.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M382.97,35.25c.15,11.36.11,22.72.17,34.07-.06,11.36-.02,22.72-.17,34.07-.15-11.36-.11-22.72-.17-34.07.06-11.36.02-22.72.17-34.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M400.56,35.25c.15,11.36.11,22.72.17,34.07-.06,11.36-.02,22.72-.17,34.07-.15-11.36-.11-22.72-.17-34.07.06-11.36.02-22.72.17-34.07Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M312.26,82.96c3.11,0,4.96-12.35,9.36-12.35s4.86,9.01,8.57,9.01,3.59-15.82,8.57-15.82,3.82,6.42,9.03,6.42,3.24-14.91,8.68-14.91,3.24,20.54,8.91,20.54c3.59,0,4.98-6.52,9.26-6.52,2.84,0,4.51,3.26,8.22,3.26s4.52-12.54,9.15-12.54,5.16,7.42,8.57,7.42,4.63-12.16,10.88-12.16v48.09h-99.19v-20.44Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M312.26,83.55v-1.19c.94,0,2.24-2.88,3.18-4.99,1.62-3.62,3.31-7.36,6.17-7.36s4.12,2.74,5.33,5.16c.95,1.89,1.92,3.85,3.24,3.85,1.16,0,2.16-3.8,2.9-6.58,1.2-4.55,2.44-9.25,5.67-9.25,2.88,0,4.01,1.85,5.01,3.47.97,1.58,1.81,2.95,4.02,2.95,2,0,2.79-3.48,3.54-6.85.89-3.96,1.81-8.06,5.14-8.06s4.14,5.16,5.03,10.62c.72,4.42,1.62,9.92,3.88,9.92,1.35,0,2.45-1.36,3.62-2.79,1.42-1.75,3.04-3.73,5.64-3.73,1.56,0,2.78.81,3.96,1.59,1.24.82,2.52,1.67,4.25,1.67,1.29,0,2.46-2.98,3.4-5.38,1.38-3.52,2.81-7.16,5.75-7.16s4.35,2.37,5.62,4.46c.92,1.52,1.8,2.97,2.95,2.97.98,0,2.09-2.31,3.07-4.35,1.67-3.48,3.75-7.81,7.81-7.81v1.19c-3.13,0-4.93,3.76-6.53,7.07-1.36,2.84-2.44,5.08-4.36,5.08s-3.06-1.75-4.18-3.61c-1.14-1.88-2.31-3.82-4.38-3.82-1.93,0-3.26,3.37-4.43,6.35-1.31,3.32-2.43,6.19-4.72,6.19s-3.75-1.02-5.11-1.92c-1.09-.72-2.02-1.34-3.11-1.34-1.87,0-3.2,1.64-4.49,3.22-1.32,1.62-2.69,3.3-4.77,3.3-3.47,0-4.34-5.31-5.26-10.94-.7-4.28-1.57-9.6-3.65-9.6s-3.02,3.77-3.77,7.09c-.9,4.02-1.76,7.81-4.91,7.81s-4.22-1.9-5.25-3.58c-.93-1.52-1.74-2.84-3.78-2.84s-3.33,4.61-4.31,8.32c-1.11,4.19-1.98,7.5-4.25,7.5s-3.34-2.22-4.52-4.58c-1.09-2.18-2.21-4.43-4.05-4.43s-3.55,3.66-4.87,6.59c-1.44,3.21-2.58,5.75-4.48,5.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M312.26,35.99c.11,11.23.21,22.47.22,33.7l.11,33.7-.33-.28,49.59.07,24.8.05,24.8.15-24.8.15-24.8.05-49.59.07h-.33s0-.28,0-.28l.11-33.7c0-11.23.11-22.47.22-33.7Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 426.41,
    y: 12.34,
    width: 3.24,
    height: 107.55
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 283.14,
    y: 7.74,
    width: 3.24,
    height: 116.96
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 79.95,
    y: 86.37,
    width: 83.6,
    height: 54.59
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.22,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 98.04,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.87,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.69,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 127.51,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.33,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.15,
    y: 96.87,
    width: 8.13,
    height: 8.13
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.22,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.04,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.87,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.69,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 127.51,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.33,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.15,
    y: 106.76,
    width: 8.13,
    height: 8.13
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.22,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.04,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.87,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.69,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 127.51,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.33,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.15,
    y: 116.65,
    width: 8.13,
    height: 8.13
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.22,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.04,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 107.87,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 117.69,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 127.51,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.33,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.15,
    y: 126.54,
    width: 8.13,
    height: 8.13
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 83.23,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 90.61,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 98,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 105.39,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 112.78,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 120.17,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 127.55,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 134.94,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 142.33,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 149.72,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 157.1,
    y: 80.58,
    width: 3.17,
    height: 8.39
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 158.11,
    y: 35.56,
    width: 193.25,
    height: 256.68
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 158.11,
    y: 35.56,
    width: 193.25,
    height: 256.68
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 171.25,
    y: 46.89,
    width: 170.6,
    height: 231.26,
    transform: "translate(-2.05 3.28) rotate(-.73)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 138.29,
    y: 77.21,
    width: 231.26,
    height: 170.6,
    transform: "translate(85.97 412.87) rotate(-88.76)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.06,
    y: 46.89,
    width: 170.6,
    height: 231.26
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 129.37,
    width: 77.54,
    height: 2.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 134.88,
    width: 77.54,
    height: 2.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 193.02,
    y: 179.84,
    width: 128.66,
    height: 2.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 193.02,
    y: 185.36,
    width: 73.74,
    height: 2.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 140.4,
    width: 77.54,
    height: 2.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 145.91,
    width: 60.84,
    height: 2.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 155.59,
    width: 77.54,
    height: 2.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 161.1,
    width: 77.54,
    height: 2.5
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 244.15,
    y: 166.62,
    width: 60.84,
    height: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.54,132.66l-5.4,18.91v19.66c-10.85,0-19.65-8.81-19.65-19.66s8.8-19.66,19.65-19.66c1.88,0,3.69.27,5.4.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M224.79,167.4c-3.26,2.41-7.28,3.83-11.64,3.83v-19.66l11.64,15.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M232.8,151.57c0,6.5-3.16,12.26-8.02,15.83l-11.64-15.83,15.29-12.36c2.73,3.37,4.37,7.68,4.37,12.36Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.8,132.85l-15.29,12.36,5.4-18.91c3.94,1.13,7.38,3.44,9.89,6.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,198.85l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,202.14l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,205.43l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,208.72l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,212l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,215.29l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,218.58l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,221.87l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,225.16l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,228.44l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,231.73l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,235.02l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,238.31l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,241.6l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M193.02,244.88l44.02-.11c14.67.04,29.34.01,44.02.11-14.67.09-29.34.07-44.02.11l-44.02-.11Z"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.33,
    y: 221.87,
    width: 6.68,
    height: 26.85
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 214.72,
    y: 210.51,
    width: 6.68,
    height: 38.21
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 227.1,
    y: 218.69,
    width: 6.68,
    height: 30.02
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 239.49,
    y: 208.72,
    width: 6.68,
    height: 40
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 251.87,
    y: 214.08,
    width: 6.68,
    height: 34.64
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 264.25,
    y: 233.7,
    width: 6.68,
    height: 15.01
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M195.41,196.54l.18,13.04.13,13.04c.09,8.7.11,17.39.13,26.09l-.43-.4,21.41-.02,21.41.05,21.41.13,21.41.24-21.41.24-21.41.13-21.41.05-21.41-.02h-.43s0-.4,0-.4c.02-8.7.04-17.39.13-26.09l.13-13.04.18-13.04Z"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 202.33,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 214.72,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 227.1,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 239.49,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 251.87,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 264.25,
    y: 251.47,
    width: 6.68,
    height: 0.55
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 297.59,
    y: 200.89,
    width: 24.1,
    height: 1.31
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 297.59,
    y: 203.62,
    width: 19.51,
    height: 1.31
  }))), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 290.61,
    y: 200.87,
    width: 4.08,
    height: 4.08
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 297.59,
    y: 214.31,
    width: 24.1,
    height: 1.31
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 297.59,
    y: 217.04,
    width: 19.51,
    height: 1.31
  }))), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 290.61,
    y: 214.29,
    width: 4.08,
    height: 4.08
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 297.59,
    y: 227.73,
    width: 24.1,
    height: 1.31
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 297.59,
    y: 230.46,
    width: 19.51,
    height: 1.31
  }))), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 290.61,
    y: 227.71,
    width: 4.08,
    height: 4.08
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 193.02,
    y: 73,
    width: 58.74,
    height: 4.05
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 193.02,
    y: 80.37,
    width: 58.74,
    height: 4.05
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M321,73.69v10.04h-61.34v-10.04h61.34M321.69,73h-62.72v11.42h62.72v-11.42h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "204.2 118.19 204.16 114.51 204.14 110.84 204.11 103.48 204.14 96.12 204.16 92.44 204.2 88.76 204.25 92.44 204.27 96.12 204.3 103.48 204.27 110.84 204.25 114.51 204.2 118.19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "214.44 118.19 214.39 114.51 214.38 110.84 214.34 103.48 214.38 96.12 214.39 92.44 214.44 88.76 214.48 92.44 214.5 96.12 214.53 103.48 214.5 110.84 214.48 114.51 214.44 118.19"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "224.67 118.19 224.63 114.51 224.61 110.84 224.58 103.48 224.61 96.12 224.63 92.44 224.67 88.76 224.72 92.44 224.74 96.12 224.77 103.48 224.74 110.84 224.72 114.51 224.67 118.19"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "234.91 118.19 234.86 114.51 234.85 110.84 234.81 103.48 234.85 96.12 234.86 92.44 234.91 88.76 234.96 92.44 234.97 96.12 235 103.48 234.97 110.84 234.96 114.51 234.91 118.19"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "245.14 118.19 245.1 114.51 245.08 110.84 245.05 103.48 245.08 96.12 245.1 92.44 245.14 88.76 245.19 92.44 245.21 96.12 245.24 103.48 245.21 110.84 245.19 114.51 245.14 118.19"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "255.38 118.19 255.33 114.51 255.32 110.84 255.29 103.48 255.32 96.12 255.33 92.44 255.38 88.76 255.43 92.44 255.44 96.12 255.48 103.48 255.44 110.84 255.43 114.51 255.38 118.19"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "265.62 118.19 265.57 114.51 265.55 110.84 265.52 103.48 265.55 96.12 265.57 92.44 265.62 88.76 265.66 92.44 265.68 96.12 265.71 103.48 265.68 110.84 265.66 114.51 265.62 118.19"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "275.85 118.19 275.81 114.51 275.79 110.84 275.76 103.48 275.79 96.12 275.81 92.44 275.85 88.76 275.9 92.44 275.91 96.12 275.95 103.48 275.91 110.84 275.9 114.51 275.85 118.19"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "286.09 118.19 286.04 114.51 286.02 110.84 285.99 103.48 286.02 96.12 286.04 92.44 286.09 88.76 286.13 92.44 286.15 96.12 286.18 103.48 286.15 110.84 286.13 114.51 286.09 118.19"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "296.32 118.19 296.28 114.51 296.26 110.84 296.23 103.48 296.26 96.12 296.28 92.44 296.32 88.76 296.37 92.44 296.39 96.12 296.42 103.48 296.39 110.84 296.37 114.51 296.32 118.19"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "306.56 118.19 306.51 114.51 306.5 110.84 306.46 103.48 306.5 96.12 306.51 92.44 306.56 88.76 306.6 92.44 306.62 96.12 306.65 103.48 306.62 110.84 306.6 114.51 306.56 118.19"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "316.79 118.19 316.75 114.51 316.73 110.84 316.7 103.48 316.73 96.12 316.75 92.44 316.79 88.76 316.84 92.44 316.86 96.12 316.89 103.48 316.86 110.84 316.84 114.51 316.79 118.19"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "193.02 88.76 225.19 88.7 257.36 88.67 289.52 88.7 321.69 88.76 289.52 88.83 257.36 88.86 225.19 88.83 193.02 88.76"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "193.02 95.89 225.19 95.83 257.36 95.8 289.52 95.83 321.69 95.89 289.52 95.96 257.36 95.99 225.19 95.96 193.02 95.89"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "193.02 103.02 225.19 102.96 257.36 102.93 289.52 102.96 321.69 103.02 289.52 103.09 257.36 103.12 225.19 103.09 193.02 103.02"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "193.02 110.15 225.19 110.09 257.36 110.06 289.52 110.09 321.69 110.15 289.52 110.22 257.36 110.25 225.19 110.22 193.02 110.15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M193.97,103.02l10.21-3.65h0s0,0,0,0l10.23-.55h.02s.02,0,.02,0l10.24,4.07h-.03s10.24,1.81,10.24,1.81h-.04s10.23-.91,10.23-.91l-.07.02c3.41-1.83,6.81-3.67,10.23-5.48l.03-.02h.04s10.24-.78,10.24-.78h.02s.02,0,.02,0l10.23,2.12h-.08s10.24-3.89,10.24-3.89h.03s.03,0,.03,0l10.23,1.09h-.03s10.25-2.5,10.25-2.5h0s0,0,0,0l3.81.02-3.81.02h0s-10.22,2.63-10.22,2.63h-.01s-.02,0-.02,0l-10.24-1.04h.05s-10.23,3.94-10.23,3.94h-.04s-.04,0-.04,0l-10.24-2.08h.04s-10.23.82-10.23.82l.07-.02c-3.4,1.84-6.82,3.64-10.24,5.46l-.03.02h-.04s-10.24.86-10.24.86h-.02s-.02,0-.02,0l-10.23-1.86h-.01s-.01,0-.01,0l-10.23-4.11h.04s-10.24.47-10.24.47h.02s-10.26,3.52-10.26,3.52Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M205.06,99.44c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M204.2,100.48c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM204.2,98.77c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M215.29,98.95c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M214.44,100c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM214.44,98.29c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M235.76,104.86c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M234.91,105.91c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM234.91,104.2c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 255.32,
    cy: 98.58,
    r: 0.85
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M255.32,99.63c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM255.32,97.92c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 275.85,
    cy: 99.9,
    r: 0.85
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M275.85,100.94c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM275.85,99.24c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 245.14,
    cy: 104.01,
    r: 0.85
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.14,105.05c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM245.14,103.35c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 265.62,
    cy: 97.73,
    r: 0.85
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M265.62,98.77c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM265.62,97.07c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M297.18,96.88c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M296.32,97.92c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM296.32,96.21c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M307.41,94.39c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306.56,95.43c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM306.56,93.73c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M286.94,95.84c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M286.09,96.89c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM286.09,95.18c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 224.67,
    cy: 103.02,
    r: 0.85
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M224.67,104.07c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM224.67,102.36c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M193.97,110.2l10.23-1.33h-.03s10.21-7.04,10.21-7.04h.01s.01-.01.01-.01l10.23-3.84.04-.02h.04s10.24,3.44,10.24,3.44h.02s.02.02.02.02l10.25,6.36h-.16c3.41-1.37,6.81-2.74,10.23-4.07l.08-.03.07.04,10.23,5.08-.19.04,10.25-12.04.06-.07.09.03,10.23,3.85h-.05s10.24-1.25,10.24-1.25h0s0,0,0,0l10.23.53h0s3.82-1.29,3.82-1.29l-3.81,1.34h0s0,0,0,0l-10.24-.4h.01s-10.23,1.3-10.23,1.3h-.03s-.03,0-.03,0l-10.24-3.81.15-.04-10.22,12.07-.08.1-.11-.06-10.25-5.04h.15c-3.41,1.37-6.82,2.7-10.24,4.05l-.08.03-.07-.05-10.22-6.39h.03s-10.23-3.46-10.23-3.46h.09s-10.24,3.79-10.24,3.79h.02s-10.26,6.97-10.26,6.97h-.01s-.02.01-.02.01l-10.24,1.2Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M205.06,108.93c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M204.2,109.98c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM204.2,108.27c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M215.29,101.92c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M214.44,102.96c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM214.44,101.25c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M235.76,101.61c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M234.91,102.66c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM234.91,100.95c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 255.32,
    cy: 104.01,
    r: 0.85
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M255.32,105.05c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM255.32,103.35c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 275.85,
    cy: 96.88,
    r: 0.85
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M275.85,97.92c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM275.85,96.21c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M246,107.8c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M245.14,108.84c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM245.14,107.13c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 265.62,
    cy: 108.78,
    r: 0.85
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M265.62,109.82c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM265.62,108.12c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M297.18,99.44c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M296.32,100.49c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM296.32,98.78c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M307.41,99.9c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M306.56,100.94c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM306.56,99.24c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M286.94,100.75c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M286.09,101.8c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM286.09,100.09c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.53,98.1c0,.47-.38.85-.85.85s-.85-.38-.85-.85.38-.85.85-.85.85.38.85.85Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M224.67,99.14c-.58,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04,1.04.47,1.04,1.04-.47,1.04-1.04,1.04ZM224.67,97.44c-.37,0-.66.3-.66.66s.3.66.66.66.66-.3.66-.66-.3-.66-.66-.66Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M193.97,87.25l.07,14.67.04,14.67-.11-.11,31.93-.05,15.97-.03,15.97.02,31.93.05c10.64,0,21.29.06,31.93.11-10.64.05-21.29.11-31.93.11l-31.93.05-15.97.02-15.97-.03-31.93-.05h-.11s0-.11,0-.11l.04-14.67.07-14.67Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M201.68,119.61s.03,0,.03.02c.03.09.11.15.21.15.12,0,.22-.1.22-.21v-.5s.01-.03.03-.03.03.01.03.03v.5c0,.15-.12.27-.27.27-.12,0-.22-.08-.26-.19,0-.01,0-.03.02-.04Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M202.82,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM202.47,119.57h.32l-.16-.43-.16.43Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M203.17,119.15v.65s-.01.03-.03.03-.03-.01-.03-.03v-.73s0-.02.01-.03c.01,0,.03,0,.04,0l.48.67v-.65s.01-.03.03-.03c.02,0,.03.01.03.03v.74s-.01.03-.03.03c0,0-.02,0-.02-.01,0,0,0,0,0,0l-.48-.67Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M203.94,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.14.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M205.24,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM204.9,119.57h.32l-.16-.43-.16.43Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M205.94,119.65c0-.06-.03-.09-.06-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM205.78,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M206.44,119.45l-.27-.37s0-.03,0-.04c.01-.01.03,0,.04,0l.25.34.25-.34s.03-.01.04,0c.01,0,.01.03,0,.04l-.27.36v.36s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.36Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M211.73,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.34s.03.01.03.03c0,.01-.01.03-.03.03h-.34v.34s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M212.42,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M213.09,119.06s.01-.03.03-.03h.18c.11,0,.2.09.2.2,0,.06-.03.12-.08.16.09.03.16.12.16.22,0,.13-.1.23-.23.23h-.23s-.03-.01-.03-.03v-.74ZM213.3,119.38c.08,0,.14-.06.14-.14s-.06-.14-.14-.14h-.15v.29h.15ZM213.35,119.78c.09,0,.17-.08.17-.17,0-.09-.08-.17-.17-.17h-.2v.34h.2Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M214.16,119.65c0-.06-.03-.09-.07-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.02-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM214,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M214.41,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.14.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M215.72,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM215.37,119.57h.32l-.16-.43-.16.43Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M216.41,119.65c0-.06-.03-.09-.06-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM216.25,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M216.92,119.45l-.27-.37s0-.03,0-.04c.01-.01.03,0,.04,0l.25.34.25-.34s.03-.01.04,0c.01,0,.01.03,0,.04l-.27.36v.36s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.36Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M223.4,119.15l-.26.35s-.01.01-.02.01h0s-.02,0-.02-.01l-.26-.35v.66s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.74s0-.02.01-.02c0,0,0,0,0,0,.01,0,.03,0,.04,0l.28.39.28-.39s.03-.01.04,0c0,0,0,0,0,0,0,0,0,.01,0,.01v.74s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.66Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M224.11,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM223.76,119.57h.32l-.16-.43-.16.43Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M224.8,119.65c0-.06-.03-.09-.07-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM224.64,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M225.5,119.02c.1,0,.19.03.26.09.01.01.01.03,0,.04,0,.01-.03.01-.04,0-.06-.05-.14-.08-.22-.08-.2,0-.36.16-.36.35s.16.35.36.35c.08,0,.16-.03.22-.08.01,0,.03,0,.04,0,.01.01,0,.03,0,.04-.07.05-.16.09-.26.09-.23,0-.42-.18-.42-.4s.19-.41.42-.41Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M226.46,119.46h-.41v.34s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03c.02,0,.03.01.03.03v.34h.41v-.34s.01-.03.03-.03c.02,0,.03.01.03.03v.74s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.34Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M233.92,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM233.57,119.57h.32l-.16-.43-.16.43Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M234.21,119.06s.01-.03.03-.03h.23c.13,0,.23.1.23.23s-.1.23-.23.23h-.2v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74ZM234.47,119.44c.09,0,.17-.08.17-.17s-.08-.17-.17-.17h-.2v.35h.2Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M235.27,119.65c0-.06-.03-.09-.06-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.02-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM235.12,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M235.6,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.74s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M235.97,119.83h0s-.03-.01-.03-.03v-.74s.01-.03.03-.03c.02,0,.03.01.03.03v.72h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M244.77,119.15l-.26.35s-.01.01-.02.01h0s-.02,0-.02-.01l-.26-.35v.66s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.74s0-.02.01-.02c0,0,0,0,0,0,.01,0,.03,0,.04,0l.28.39.28-.39s.03-.01.04,0c0,0,0,0,0,0,0,0,0,.01,0,.01v.74s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.66Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M245.47,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0-.01,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM245.13,119.57h.32l-.16-.43-.16.43Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M245.91,119.45l-.27-.37s0-.03,0-.04c.01-.01.03,0,.04,0l.25.34.25-.34s.03-.01.04,0c.01,0,.01.03,0,.04l-.27.36v.36s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.36Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M253.92,119.61s.03,0,.03.02c.03.09.11.15.21.15.12,0,.22-.1.22-.21v-.5s.01-.03.03-.03.03.01.03.03v.5c0,.15-.12.27-.27.27-.12,0-.22-.08-.26-.19,0-.01,0-.03.02-.04Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M254.64,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.14.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M255.61,119.15v.65s-.01.03-.03.03-.03-.01-.03-.03v-.73s0-.02.01-.03c.01,0,.03,0,.04,0l.48.67v-.65s.01-.03.03-.03c.02,0,.03.01.03.03v.74s-.01.03-.03.03c0,0-.02,0-.02-.01,0,0,0,0,0,0l-.48-.67Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M256.36,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M264.32,119.61s.03,0,.03.02c.03.09.11.15.21.15.12,0,.22-.1.22-.21v-.5s.01-.03.03-.03.03.01.03.03v.5c0,.15-.12.27-.27.27-.12,0-.22-.08-.26-.19,0-.01,0-.03.02-.04Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.05,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.14.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.95,119.83h0s-.03-.01-.03-.03v-.74s.01-.03.03-.03c.02,0,.03.01.03.03v.72h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M266.63,119.45l-.27-.37s0-.03,0-.04c.01-.01.03,0,.04,0l.25.34.25-.34s.03-.01.04,0c.01,0,.01.03,0,.04l-.27.36v.36s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.36Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M273.92,119.63h-.36l-.07.19s-.01.02-.03.02c0,0,0,0,0,0-.01,0-.02-.02-.02-.04l.28-.74s.02-.02.03-.02c.01,0,.02,0,.03.02l.28.74s0,.03-.01.04c0,0,0,0-.01,0-.01,0-.02,0-.03-.02l-.07-.19ZM273.58,119.57h.32l-.16-.43-.16.43Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M274.19,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.14.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275.49,119.47s-.03-.01-.03-.03.01-.03.03-.03h.25s.03.01.03.03v.27h0s0,.02-.01.03c-.07.06-.16.09-.26.09-.23,0-.42-.18-.42-.41s.19-.4.42-.4c.1,0,.19.03.26.09.01,0,.01.03,0,.04,0,.01-.03.01-.04,0-.06-.05-.14-.08-.22-.08-.2,0-.36.16-.36.35s.16.35.36.35c.08,0,.15-.03.21-.07v-.23h-.22Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.05,119.06s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.15.12.27.27.27.15,0,.27-.12.27-.27v-.45s.01-.03.03-.03c.02,0,.03.01.03.03v.45c0,.18-.15.32-.32.32s-.32-.14-.32-.32v-.45Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M276.94,119.68s.03-.01.04,0c.06.05.16.1.26.1.07,0,.13-.02.18-.05.04-.03.07-.07.07-.12s-.02-.08-.06-.11c-.04-.03-.11-.05-.19-.06h0c-.07-.01-.14-.03-.19-.07-.05-.03-.08-.08-.08-.14s.03-.11.08-.15c.05-.04.12-.06.19-.06.1,0,.18.05.25.09.01,0,.01.02,0,.04,0,.01-.02.01-.03,0-.06-.04-.13-.08-.22-.08-.06,0-.12.02-.16.05-.04.03-.06.07-.06.11,0,.04.02.07.06.1.04.03.1.05.17.06h0c.08.01.15.04.2.07.05.03.09.09.09.15s-.04.12-.09.16c-.05.04-.13.06-.21.06-.12,0-.23-.06-.29-.12-.01,0-.01-.02,0-.04Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M277.92,119.09h-.24s-.03-.01-.03-.03c0-.01.01-.03.03-.03h.54s.03.01.03.03c0,.02-.01.03-.03.03h-.24v.72s-.01.03-.03.03-.03-.01-.03-.03v-.72Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M282.89,119.68s.03-.01.04,0c.06.05.16.1.26.1.07,0,.13-.02.18-.05.04-.03.07-.07.07-.12s-.02-.08-.06-.11c-.04-.03-.11-.05-.18-.06h0c-.07-.01-.14-.03-.19-.07-.05-.03-.08-.08-.08-.14s.03-.11.08-.15c.05-.04.12-.06.19-.06.1,0,.18.05.25.09.01,0,.02.02,0,.04,0,.01-.02.01-.03,0-.06-.04-.13-.08-.22-.08-.07,0-.12.02-.16.05-.04.03-.06.07-.06.11,0,.04.02.07.06.1.04.03.1.05.17.06h0c.08.01.15.04.2.07.05.03.09.09.09.15s-.04.12-.09.16c-.05.04-.13.06-.21.06-.12,0-.23-.06-.29-.12-.01,0-.01-.02,0-.04Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M283.69,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M284.36,119.06s.01-.03.03-.03h.23c.13,0,.23.1.23.23s-.1.23-.23.23h-.2v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74ZM284.61,119.44c.09,0,.17-.08.17-.17s-.08-.17-.17-.17h-.2v.35h.2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M285.23,119.09h-.24s-.03-.01-.03-.03c0-.01.01-.03.03-.03h.54s.03.01.03.03c0,.02-.01.03-.03.03h-.24v.72s-.01.03-.03.03-.03-.01-.03-.03v-.72Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M285.76,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M287.05,119.15l-.26.35s-.01.01-.02.01h0s-.02,0-.02-.01l-.26-.35v.66s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.74s0-.02.01-.02c0,0,0,0,0,0,.01,0,.03,0,.04,0l.28.39.28-.39s.03-.01.04,0c0,0,0,0,0,0,0,0,0,.01,0,.01v.74s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.66Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M287.4,119.06s.01-.03.03-.03h.18c.11,0,.2.09.2.2,0,.06-.03.12-.08.16.09.03.16.12.16.22,0,.13-.1.23-.23.23h-.23s-.03-.01-.03-.03v-.74ZM287.6,119.38c.08,0,.14-.06.14-.14s-.06-.14-.14-.14h-.15v.29h.15ZM287.65,119.78c.09,0,.17-.08.17-.17,0-.09-.08-.17-.17-.17h-.2v.34h.2Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M288.08,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M289.17,119.65c0-.06-.03-.09-.07-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM289.01,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.04,119.02c.21,0,.38.18.38.41,0,.22-.17.4-.38.4s-.38-.18-.39-.4c0-.22.17-.41.39-.41ZM294.04,119.78c.18,0,.32-.15.33-.35,0-.2-.15-.35-.33-.35s-.33.15-.33.35.15.35.33.35Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M295,119.02c.1,0,.19.03.26.09.01.01.01.03,0,.04,0,.01-.03.01-.04,0-.06-.05-.14-.08-.22-.08-.2,0-.36.16-.36.35s.16.35.36.35c.08,0,.16-.03.22-.08.01,0,.03,0,.04,0,.01.01,0,.03,0,.04-.07.05-.16.09-.26.09-.23,0-.42-.18-.42-.4s.19-.41.42-.41Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M295.71,119.09h-.24s-.03-.01-.03-.03c0-.01.01-.03.03-.03h.54s.03.01.03.03c0,.02-.01.03-.03.03h-.24v.72s-.01.03-.03.03-.03-.01-.03-.03v-.72Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M296.53,119.02c.21,0,.38.18.38.41,0,.22-.17.4-.38.4s-.38-.18-.39-.4c0-.22.17-.41.39-.41ZM296.53,119.78c.18,0,.32-.15.33-.35,0-.2-.15-.35-.33-.35s-.33.15-.33.35.15.35.33.35Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M297.11,119.06s.01-.03.03-.03h.18c.11,0,.2.09.2.2,0,.06-.03.12-.08.16.09.03.16.12.16.22,0,.13-.1.23-.23.23h-.23s-.03-.01-.03-.03v-.74ZM297.31,119.38c.08,0,.14-.06.14-.14s-.06-.14-.14-.14h-.15v.29h.15ZM297.36,119.78c.09,0,.17-.08.17-.17,0-.09-.08-.17-.17-.17h-.2v.34h.2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M297.78,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M298.88,119.65c0-.06-.03-.09-.06-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM298.72,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M303.59,119.15v.65s-.01.03-.03.03-.03-.01-.03-.03v-.73s0-.02.01-.03c.01,0,.03,0,.04,0l.48.67v-.65s.01-.03.03-.03c.02,0,.03.01.03.03v.74s-.01.03-.03.03c0,0-.02,0-.02-.01,0,0,0,0,0,0l-.48-.67Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.71,119.02c.21,0,.38.18.38.41,0,.22-.17.4-.38.4s-.38-.18-.39-.4c0-.22.17-.41.39-.41ZM304.71,119.78c.18,0,.32-.15.33-.35,0-.2-.15-.35-.33-.35s-.33.15-.33.35.15.35.33.35Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M305.54,119.82s0,0,0,0h0s-.31-.74-.31-.74c0-.01,0-.03.01-.04.01,0,.03,0,.04.01l.29.68.29-.68s.02-.02.04-.01c.01,0,.02.02.01.04l-.31.73s0,.02-.02.02h0s0,0-.01,0c0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.01-.01Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M306.1,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M307.39,119.15l-.26.35s-.01.01-.02.01h0s-.02,0-.02-.01l-.26-.35v.66s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.74s0-.02.01-.02c0,0,0,0,0,0,.01,0,.03,0,.04,0l.28.39.28-.39s.03-.01.04,0c0,0,0,0,0,0,0,0,0,.01,0,.01v.74s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.66Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M307.73,119.06s.01-.03.03-.03h.18c.11,0,.2.09.2.2,0,.06-.03.12-.08.16.09.03.16.12.16.22,0,.13-.1.23-.23.23h-.23s-.03-.01-.03-.03v-.74ZM307.94,119.38c.08,0,.14-.06.14-.14s-.06-.14-.14-.14h-.15v.29h.15ZM307.99,119.78c.09,0,.17-.08.17-.17,0-.09-.08-.17-.17-.17h-.2v.34h.2Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M308.41,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M309.5,119.65c0-.06-.03-.09-.06-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01,0,.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM309.34,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M313.92,119.83h0s-.03-.01-.03-.03v-.74s.01-.03.03-.03h.15c.22,0,.4.18.4.4s-.18.4-.4.4h-.15ZM314.07,119.78c.19,0,.34-.15.34-.34s-.15-.34-.34-.34h-.12v.69h.12Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M314.66,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M315.71,119.02c.1,0,.19.03.26.09.01.01.01.03,0,.04,0,.01-.03.01-.04,0-.06-.05-.14-.08-.22-.08-.2,0-.36.16-.36.35s.16.35.36.35c.08,0,.16-.03.22-.08.01,0,.03,0,.04,0,.01.01,0,.03,0,.04-.07.05-.16.09-.26.09-.23,0-.42-.18-.42-.4s.19-.41.42-.41Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M316.21,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M317.5,119.15l-.26.35s-.01.01-.02.01h0s-.02,0-.02-.01l-.26-.35v.66s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.74s0-.02.01-.02c0,0,0,0,0,0,.01,0,.03,0,.04,0l.28.39.28-.39s.03-.01.04,0c0,0,0,0,0,0,0,0,0,.01,0,.01v.74s-.01.03-.03.03c-.02,0-.03-.01-.03-.03v-.66Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M317.84,119.06s.01-.03.03-.03h.18c.11,0,.2.09.2.2,0,.06-.03.12-.08.16.09.03.16.12.16.22,0,.13-.1.23-.23.23h-.23s-.03-.01-.03-.03v-.74ZM318.05,119.38c.08,0,.14-.06.14-.14s-.06-.14-.14-.14h-.15v.29h.15ZM318.1,119.78c.09,0,.17-.08.17-.17,0-.09-.08-.17-.17-.17h-.2v.34h.2Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M318.52,119.06s.01-.03.03-.03h.41s.03.01.03.03c0,.02-.01.03-.03.03h-.38v.32h.33s.03.01.03.03c0,.01-.01.03-.03.03h-.33v.31h.38s.03.01.03.03c0,.01-.01.03-.03.03h-.41s-.03-.01-.03-.03v-.74Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M319.62,119.65c0-.06-.03-.09-.07-.12-.04-.03-.08-.04-.09-.04,0,0,0,0,0,0h-.19v.32s-.01.03-.03.03c-.01,0-.03-.01-.03-.03v-.74s.01-.03.03-.03h.23c.13,0,.23.1.23.23,0,.09-.05.17-.13.21,0,0,0,0,.01,0,.05.03.11.09.11.18,0,.05,0,.08.01.09,0,.01.01.02.01.02.01,0,.03,0,.03.02,0,.01,0,.03-.02.04,0,0,0,0-.01,0h0s-.04-.01-.05-.04c-.01-.03-.02-.06-.02-.13ZM319.46,119.09h-.2v.34h.2c.09,0,.17-.08.17-.17s-.08-.17-.17-.17Z"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 191.67,
    y: 256.01,
    width: 128.66,
    height: 0.93
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 193.02,
    y: 258.42,
    width: 128.66,
    height: 0.93
  }))), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.98,
    y: 30.88,
    width: 83.79,
    height: 25.55
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M278.49,16.91h-52l-2.3,13.97h57.38l-3.07-13.97ZM252.87,26.96c-1.69,0-3.07-1.37-3.07-3.07,0-1.69,1.38-3.07,3.07-3.07s3.07,1.38,3.07,3.07-1.37,3.07-3.07,3.07Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.57 30.87 224.19 30.87 224.7 27.75 280.88 27.75 281.57 30.87"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.52,385.83c122.26-.53,259.41-.53,381.67,0-122.26.53-259.41.53-381.67,0h0Z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M343.77,103.1c-.36-30.16-24.59-54.16-53.99-53.51-14.22.32-27.54,6.31-37.51,16.88-9.96,10.57-15.35,24.42-15.17,39.01.17,14.58,5.9,28.19,16.11,38.32,10.21,10.11,23.67,15.51,37.89,15.19,14.22-.32,27.54-6.31,37.5-16.88,9.96-10.57,15.35-24.42,15.17-39.01Z"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.19,319.26c3.93,8.98,15.11,55.53,15.11,55.53h21.45s-.69-6.12,1.13-14.64c1.55-7.23,5.83-16.18,4.16-24.56-3.64-18.26-10.79-24.38-10.79-24.38l9.03-31.55c4.45,10.93,7.07,26.7,9.28,32.54,2.82,7.47,6.56,13.63,6.56,13.63l18.55,48.97h21.45s-1.3-6.69-.92-15.53c.42-9.73,4-22.08-.14-30.96-4.37-9.38-1.66-14.38-1.66-14.38,0,0-10.76-39.49-11.43-45.43-.87-7.63-1.04-7.56-5.03-25.2l-72.65,4.35s-9.58,59.12-4.11,71.63Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M382.96,287.44c2.9,9.62,4.87,20.21,6.59,24.76,2.82,7.47,6.56,13.63,6.56,13.63l18.55,48.97h4.92s-18.55-48.97-18.55-48.97c0,0-3.74-6.15-6.56-13.63-2.2-5.84-4.83-21.61-9.28-32.54l-2.23,7.77Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.18,319.26c3.93,8.98,15.11,55.53,15.11,55.53h4.92s-11.18-46.55-15.11-55.53c-5.47-12.5,4.11-71.63,4.11-71.63l67.79-4.06c-.02-.1-.04-.19-.07-.29l-72.64,4.35s-9.58,59.12-4.11,71.63Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.12,375.23h-21.45c-.18,0-.34-.11-.4-.28l-18.55-48.97h0s-3.76-6.21-6.56-13.62c-.89-2.35-1.84-6.27-2.94-10.82-1.54-6.36-3.43-14.18-5.87-20.54l-8.61,30.07c1.23,1.17,7.4,7.75,10.72,24.43,1.23,6.17-.72,12.67-2.43,18.41-.67,2.23-1.3,4.34-1.72,6.33-1.79,8.34-1.13,14.44-1.12,14.5.01.12-.03.24-.11.33-.08.09-.2.14-.32.14h-21.45c-.2,0-.37-.14-.42-.33-.11-.47-11.22-46.62-15.08-55.46h0c-5.46-12.48,3.69-69.45,4.08-71.87.03-.2.2-.35.4-.36l72.65-4.35c.21-.02.4.13.44.33.71,3.14,1.3,5.73,1.79,7.89,2.29,10.02,2.53,11.07,3.24,17.36.66,5.84,11.31,44.97,11.42,45.36.03.11.02.22-.04.32-.03.05-2.53,4.96,1.67,14,3.03,6.51,2.01,14.65,1.03,22.53-.38,3.04-.74,5.92-.86,8.63-.37,8.68.9,15.37.91,15.43.02.13,0,.26-.09.36-.08.1-.2.16-.33.16ZM414.97,374.37h20.64c-.29-1.74-1.16-7.71-.84-15.12.12-2.75.48-5.64.86-8.7.97-7.76,1.97-15.78-.96-22.06-4.03-8.66-2.17-13.65-1.73-14.61-.84-3.09-10.74-39.56-11.4-45.33-.71-6.25-.95-7.29-3.22-17.27-.47-2.08-1.04-4.55-1.71-7.53l-71.94,4.31c-.77,4.84-9.23,59.29-4.09,71.05,3.77,8.62,13.97,50.76,15.05,55.27h20.64c-.12-1.61-.35-7.16,1.18-14.3.43-2.02,1.07-4.15,1.74-6.39,1.69-5.64,3.6-12.04,2.42-18-3.56-17.86-10.58-24.08-10.65-24.14-.13-.11-.18-.28-.13-.44l9.03-31.55c.05-.18.21-.3.39-.31.18-.03.35.1.42.27,2.69,6.61,4.73,15.05,6.38,21.83,1.09,4.52,2.04,8.42,2.91,10.71,2.77,7.34,6.49,13.49,6.53,13.55l18.48,48.76Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.24,368.13c1.02-.14,1.97-.36,2.8-.66l6.04-2.33c4.35-1.68,9.15-1.64,13.47.12,2.2-10.6-1.32-27.68-6.46-38.7-4.37-9.38-6.87-12.64-6.87-12.64,0,0-12.45-35.91-12.25-45.43.16-7.68-2.97-19.75-5.02-25.2l-71.97.04s-10.15,65.72-4.78,75.94c3.24,6.17,6.59,31.88,10.08,46l.6.22c2.4.86,4.19,1.43,6.42,1.78,3.67.57,7.41.31,11-.62l10.15-2c4.56-1.29,7.78.63,7.78.63,2.13-7.78,1.44-19.89-.66-30.39-3.64-18.26-9.45-22.17-9.45-22.17l4.16-33.03c4.45,10.93,7.07,26.7,9.28,32.54,2.82,7.47,6.56,13.63,6.56,13.63l15.26,39.43c4.22,2.44,9.08,3.54,13.87,2.87Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.72,364.97c.27.1.55.18.82.29.01-.06.02-.13.03-.19-.29-.04-.57-.08-.86-.1Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.54,312.2c2.82,7.47,6.56,13.63,6.56,13.63l15.26,39.43c2.74,1.59,5.75,2.59,8.83,2.93-1.51-.5-2.98-1.14-4.37-1.95l-15.26-39.43s-3.74-6.15-6.56-13.63c-2.2-5.84-9.29-24.44-13.74-35.37l3.33,11.81c2.55,9,4.36,18.37,5.95,22.58Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M386.03,365.16c.12.06.18.1.18.1,0-.03.01-.06.02-.09-.07,0-.13,0-.2,0Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M343.51,253.47c-2.59,18.85-7.37,58.09-3.32,65.8,3.24,6.17,6.59,31.88,10.08,46l.6.22c2.4.86,4.19,1.43,6.42,1.78.21.03.43.05.64.08-.81-.25-1.66-.54-2.6-.88l-.6-.22c-3.49-14.12-6.84-39.82-10.08-46-4.02-7.67.69-46.59,3.29-65.54-1.55-.29-3.02-.68-4.43-1.23Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.49,368.75c-3.86,0-7.8-1.07-11.33-3.12-.08-.05-.15-.13-.19-.22l-15.26-39.43h0s-3.76-6.21-6.56-13.63c-.89-2.35-1.84-6.27-2.94-10.82-1.51-6.23-3.36-13.86-5.72-20.14l-3.92,31.11c1.12.91,6.13,5.82,9.41,22.28,1.84,9.22,2.98,22.1.65,30.59-.04.13-.13.23-.25.28-.12.05-.26.04-.38-.03-.03-.02-3.13-1.8-7.44-.59l-10.18,2.01c-3.75.98-7.51,1.19-11.15.63-2.2-.34-3.98-.89-6.5-1.8l-.61-.22c-.13-.05-.24-.16-.27-.3-1.38-5.59-2.76-13.06-4.08-20.28-1.98-10.79-4.03-21.94-5.96-25.62-5.37-10.23,4.32-73.51,4.74-76.2.03-.21.21-.36.42-.36l71.97-.04c.18,0,.34.11.4.28,2.13,5.66,5.21,17.63,5.05,25.37-.19,9.15,11.62,43.5,12.21,45.21.36.49,2.8,3.9,6.88,12.67,4.89,10.5,8.83,27.72,6.49,38.97-.03.13-.11.23-.22.29-.11.06-.25.07-.36.02-4.23-1.72-8.9-1.76-13.15-.12l-6.04,2.33c-.82.3-1.79.53-2.89.69h0c-.93.13-1.87.19-2.81.19ZM425.24,368.13h0,0ZM411.72,364.96c4.2,2.4,8.97,3.37,13.46,2.74h0c1.04-.15,1.96-.36,2.71-.64l6.03-2.33c4.3-1.66,9-1.68,13.3-.06,2-10.69-1.7-27.57-6.53-37.93-4.29-9.21-6.8-12.53-6.82-12.56-.03-.04-.05-.08-.06-.12-.51-1.47-12.48-36.09-12.28-45.58.15-7.18-2.71-18.85-4.89-24.77l-71.3.04c-.8,5.29-9.81,65.72-4.77,75.31,1.99,3.79,3.96,14.51,6.05,25.86,1.31,7.11,2.66,14.46,4.02,20.01l.39.14c2.47.89,4.21,1.43,6.34,1.76,3.53.54,7.17.34,10.83-.62l10.17-2.01c3.66-1.04,6.48-.07,7.58.43,1.76-7.02,1.47-18.32-.8-29.68-3.55-17.79-9.21-21.86-9.27-21.9-.13-.09-.2-.25-.18-.41l4.16-33.03c.02-.19.18-.35.37-.37.19-.03.38.08.45.26,2.69,6.61,4.73,15.05,6.38,21.83,1.09,4.52,2.04,8.42,2.9,10.71,2.77,7.34,6.49,13.49,6.53,13.55l15.24,39.36Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M376.74,385.83h-38.35s16.9-11.03,16.9-11.03h21.45v11.03Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.74,386.26h-38.35c-.19,0-.36-.13-.41-.31-.05-.18.02-.38.18-.48l16.9-11.03c.07-.05.15-.07.24-.07h21.45c.24,0,.43.19.43.43v11.03c0,.24-.19.43-.43.43ZM339.84,385.4h36.47v-10.17h-20.89l-15.58,10.17Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M436.11,385.83h-38.35s16.9-11.03,16.9-11.03h21.45v11.03Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.11,386.26h-38.35c-.19,0-.36-.13-.41-.31-.05-.18.02-.38.18-.48l16.9-11.03c.07-.05.15-.07.24-.07h21.45c.24,0,.43.19.43.43v11.03c0,.24-.19.43-.43.43ZM399.2,385.4h36.47v-10.17h-20.89l-15.58,10.17Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.73,210.97s-.08,0-.12-.02l-14.36-4.35c-.23-.07-.36-.31-.29-.54.07-.23.31-.36.54-.29l14.36,4.35c.23.07.36.31.29.54-.06.19-.23.31-.41.31Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.95,158.44s-12.53,3.44-15.54,3.29c-8.66-.43-24.66,5.42-24.28,18.76.06,2.14-6.94,7.72-6.04,14.97.35,2.81,22.62,8.31,21.97,11.43-5.18,24.71-5.16,46.37-5.16,46.37,28.2,10.54,54.52.53,54.52.53,7.93-2.63,16.25-5.48,24.57-5.04l6.28,1.18s-5.08-18.9-11.53-34.94c-1.04-2.59,1.34-8.68,1.75-10.75.78-3.97,3.16-7.9,3.5-15.29.66-14.44-12.3-25.54-23.56-25.54-3.29,0-4.81-.83-6.96-1.71-5.64-2.31-10.49-2.84-10.49-2.84l-9.03-.41Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M346.23,189.91c-1.3,6.44-1.53,13.97-2.38,21.56-2.32,20.71-3.94,41.79-3.94,41.79.5.19,2.8.97,3.3,1.14.2-6.84-.93-35.8,3.08-54.92.12-.59,1.14-8.85-.07-9.57Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.08,195.46c.05.41.57.88,1.42,1.38.55-6.14,6.11-11.66,6.06-13.57-.38-13.34,15.62-19.19,24.28-18.76,3,.15,15.54-3.29,15.54-3.29l9.03.41s4.86,1.39,10.49,3.69c2.15.88,3.68.86,6.96.86,8.06,0,16.98,6.54,21.17,15.06-3.17-10.51-13.45-17.84-22.6-17.84-3.29,0-4.81-.83-6.96-1.71-5.64-2.31-10.49-2.84-10.49-2.84l-9.03-.41s-12.53,3.44-15.54,3.29c-8.66-.43-24.66,5.42-24.28,18.76.06,2.14-6.94,7.72-6.04,14.97Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.33,258.48c-8.32,0-17.86-1.19-27.57-4.82-.17-.06-.28-.22-.28-.4,0-.22.03-21.99,5.16-46.46.27-1.29-6.69-3.95-11.29-5.71-6.5-2.48-10.49-4.08-10.68-5.58-.61-4.96,2.37-9.19,4.34-11.99.92-1.31,1.72-2.44,1.7-3.02-.13-4.51,1.53-8.49,4.93-11.82,5.34-5.22,14-7.67,19.8-7.38,2.91.13,15.28-3.24,15.4-3.28.04-.01.09-.02.13-.01l9.03.41c.08,0,5.01.57,10.64,2.87.26.11.52.21.76.32,1.74.73,3.24,1.36,6.04,1.36,5.9,0,12.24,2.95,16.96,7.89,4.83,5.06,7.33,11.48,7.03,18.09-.23,4.97-1.35,8.33-2.33,11.3-.47,1.42-.92,2.76-1.17,4.06-.11.54-.33,1.32-.6,2.23-.75,2.58-1.89,6.48-1.17,8.28,6.38,15.88,11.49,34.8,11.54,34.99.04.14,0,.3-.1.4-.1.11-.25.16-.39.13l-6.28-1.18c-7.98-.4-16.02,2.26-23.79,4.84l-.57.19c-.16.06-11.54,4.29-27.23,4.29ZM340.34,252.96c27.61,10.19,53.67.52,53.93.42l.58-.19c7.85-2.61,15.96-5.31,24.16-4.88l5.66,1.06c-.96-3.49-5.64-20.08-11.33-34.23-.83-2.08.31-5.99,1.14-8.85.26-.89.48-1.65.58-2.15.27-1.36.72-2.72,1.2-4.17.97-2.91,2.07-6.21,2.29-11.06.29-6.37-2.12-12.57-6.79-17.46-4.56-4.78-10.67-7.63-16.34-7.63-2.97,0-4.55-.66-6.37-1.43-.25-.1-.5-.21-.76-.31-5.51-2.25-10.33-2.81-10.38-2.81l-8.93-.4c-1.09.3-12.65,3.41-15.61,3.29-5.61-.27-14,2.08-19.16,7.14-3.22,3.15-4.79,6.91-4.67,11.18.02.87-.77,1.99-1.86,3.54-2.01,2.85-4.76,6.76-4.19,11.39.13,1.07,5.91,3.28,10.13,4.89,7.6,2.9,12.23,4.77,11.83,6.69-4.79,22.82-5.12,43.29-5.14,45.98Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.57,152.67c1.26-1.33,2.63-2.19,3.94-2.57.13-.04.26-.07.39-.1.09-.03.18-.05.27-.06,1.83-.32,3.47.36,4.41,2.07,1.57,2.85.58,7.62-2.18,11.05-.22.27-.45.54-.69.79-.11.11-.21.21-.32.32-.35.34-.71.65-1.06.92-2.96,2.23-6.16,2.09-7.62-.57-1.69-3.09-.4-8.39,2.87-11.85Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.26,167.08c-.34,0-.68-.03-1.01-.1-1.26-.27-2.27-1.05-2.93-2.25-1.77-3.23-.46-8.77,2.93-12.35t0,0c1.28-1.35,2.71-2.27,4.13-2.68.16-.05.29-.08.42-.11.07-.02.18-.05.28-.07,2.09-.36,3.86.47,4.86,2.28,1.63,2.97.67,7.92-2.22,11.52-.22.28-.47.56-.72.82l-.32.32c-.4.38-.75.69-1.11.96-1.44,1.08-2.94,1.65-4.33,1.65ZM372.88,152.96h0c-3.15,3.33-4.41,8.42-2.81,11.35.54.98,1.35,1.61,2.35,1.82,1.38.3,3.07-.21,4.63-1.39.33-.25.66-.54,1.02-.89l.3-.31c.23-.24.46-.51.67-.77,2.69-3.34,3.61-7.89,2.14-10.57-.81-1.47-2.25-2.14-3.96-1.85-.07.01-.15.03-.23.05-.14.03-.25.06-.37.09-1.3.37-2.59,1.22-3.76,2.45Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.68,141.05c1.77-2.06,3.93-3.46,6.17-4.14.23-.07.45-.13.67-.18.16-.05.32-.09.47-.12,3.23-.66,6.52.14,8.93,2.5,4.03,3.95,4.16,10.95.5,16.21-.29.41-.61.83-.95,1.22-.15.17-.3.33-.45.5-.51.53-1.03,1.01-1.57,1.45-4.52,3.55-10.45,3.71-14.22.01-4.37-4.28-4.16-12.08.44-17.44Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M367.24,158.49c.69.68,1.46,1.22,2.27,1.65-4.26-4.3-4.03-12.02.53-17.34,1.77-2.06,3.93-3.46,6.17-4.14.22-.07.45-.14.67-.18.16-.05.32-.09.47-.12,2.31-.47,4.65-.18,6.68.88-.04-.04-.08-.09-.12-.13-2.41-2.36-5.7-3.16-8.93-2.5-.16.03-.31.07-.47.12-.22.05-.44.12-.67.18-2.24.69-4.4,2.08-6.17,4.14-4.6,5.36-4.8,13.16-.44,17.44Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.99,161.6c-2.63,0-5.14-.94-7.05-2.81-4.51-4.42-4.32-12.5.42-18.03,0,0,0,0,0,0,1.78-2.06,3.98-3.54,6.37-4.27.24-.07.47-.14.7-.19.14-.04.31-.09.48-.12,3.49-.72,6.89.24,9.31,2.61,4.14,4.06,4.38,11.26.55,16.76-.3.42-.63.86-.97,1.26-.09.11-.19.21-.28.31l-.17.19c-.56.58-1.09,1.07-1.63,1.5-2.37,1.86-5.11,2.8-7.73,2.8ZM368,141.33c-4.45,5.19-4.66,12.74-.47,16.85,3.56,3.49,9.17,3.47,13.65-.05.51-.4,1.01-.86,1.53-1.41l.17-.19c.09-.1.18-.19.26-.29.32-.38.64-.79.92-1.19,3.59-5.15,3.4-11.88-.45-15.65-2.22-2.17-5.33-3.04-8.54-2.38-.14.03-.29.06-.43.11-.24.06-.46.12-.67.19-2.24.68-4.3,2.07-5.97,4.01h0Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.34,144.55c.11.07,2.2,2.14,1.51,4.24-.92,2.82-.86,5.37,3.81,7.91.29-.06.5-.09.8-.15.34-.4.67-.83.97-1.25,3.66-5.26,3.53-12.26-.5-16.21,0,0-.01-.01-.02-.02,1.03-.65,1.66-1.9,1.42-3.29-.2-1.16-1.04-2.13-2.13-2.46-.08-.03-.16-.05-.24-.06-.87-.19-1.4-1.02-1.44-1.94-.02-.38-.17-.74-.31-1.16-.84-2.45-4.69-3.14-7.06.26-4.07,5.85-.47,11.75,3.19,14.13Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.65,157.14c-.07,0-.14-.02-.21-.05-5.05-2.75-4.91-5.68-4.01-8.42.59-1.81-1.23-3.63-1.36-3.76-1.98-1.29-4.33-3.87-4.99-7.25-.5-2.56.08-5.14,1.7-7.47,1.25-1.8,3.08-2.72,4.88-2.47,1.39.19,2.51,1.08,2.93,2.32l.07.2c.13.36.25.7.26,1.08.03.65.38,1.38,1.1,1.54.09.02.18.04.28.07,1.25.38,2.2,1.48,2.43,2.8.22,1.3-.24,2.59-1.2,3.41,3.83,4.14,3.94,11.08.22,16.42-.31.44-.65.88-1,1.28-.06.07-.15.12-.25.14l-.8.15s-.05,0-.08,0ZM377.57,144.19c.27.18,2.45,2.42,1.69,4.73-.92,2.82-.66,5.03,3.47,7.33l.5-.09c.29-.35.58-.72.84-1.1,3.59-5.16,3.4-11.89-.45-15.65-.09-.09-.15-.23-.14-.36.01-.13.08-.26.19-.33.94-.6,1.42-1.72,1.23-2.85-.17-.99-.91-1.84-1.83-2.12-.07-.02-.14-.04-.21-.05-1.02-.22-1.73-1.17-1.78-2.34-.01-.25-.11-.52-.21-.83l-.07-.21c-.32-.93-1.18-1.6-2.24-1.75-1.48-.21-2.99.58-4.06,2.11-1.5,2.16-2.02,4.45-1.56,6.81.62,3.13,2.8,5.52,4.64,6.71h0ZM377.07,144.89h0Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.08,174.18c.69,3.77,7.67,44.98,11.67,51.45,1.25,2.03,2.65,3.3,4.22,4.43,8.92,6.37,16.29.71,16.29.71l3.8-14.27-9.79-20.62s-.73-10.56-1.25-11.52c-.52-.97-4.12-12.28-4.12-12.28,0,0,.09-9.34-2.94-11.16-3.03-1.82-4.35,2.76-4.35,2.76,0,0-3.05-4.99-4.99-5.13-3.65-.27-9.88,8.33-8.55,15.64Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M309.08,174.18c.69,3.77,7.67,44.98,11.67,51.45,1.25,2.03,2.65,3.3,4.22,4.43,3.89,2.77,7.48,3.27,10.3,2.94-2.19-.25-4.66-1.08-7.26-2.94-1.57-1.12-2.97-2.4-4.22-4.43-4-6.47-10.98-47.68-11.67-51.45-1.12-6.16,3.11-13.21,6.65-15.14-.4-.29-.79-.48-1.15-.5-3.65-.27-9.88,8.33-8.55,15.64Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.7,233.49c-2.62,0-5.7-.75-8.98-3.09-1.91-1.37-3.21-2.73-4.34-4.55-2.45-3.97-6.29-20.74-11.41-49.85-.15-.83-.25-1.43-.31-1.75h0c-.91-4.98,1.5-10.35,4.3-13.47,1.65-1.83,3.32-2.77,4.7-2.68,1.68.12,3.88,3.15,4.85,4.61.37-.84,1.08-2.06,2.2-2.5.78-.3,1.61-.19,2.47.32,3.09,1.86,3.15,10.53,3.14,11.47,1.45,4.53,3.71,11.46,4.07,12.14.53.98,1.16,9.66,1.29,11.61l9.75,20.55c.04.09.05.2.03.29l-3.8,14.27c-.02.09-.08.17-.15.23-.05.04-3.19,2.39-7.82,2.39ZM317.46,158.96c-1.07,0-2.5.89-3.86,2.41-2.57,2.86-4.95,8.07-4.1,12.74h0c.06.32.17.93.31,1.76,6.35,36.12,9.65,46.88,11.3,49.54,1.34,2.16,2.83,3.39,4.11,4.3,8.05,5.75,14.69,1.5,15.67.8l3.72-13.97-9.72-20.48s-.04-.1-.04-.15c-.35-5.07-.89-10.76-1.2-11.35-.52-.97-3.78-11.19-4.15-12.35-.01-.04-.02-.09-.02-.14.02-2.53-.42-9.4-2.73-10.79-.63-.38-1.19-.46-1.71-.26-1.34.52-2,2.75-2.01,2.77-.05.16-.19.28-.36.31s-.33-.06-.42-.2c-1.13-1.86-3.4-4.84-4.65-4.93-.04,0-.09,0-.13,0Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M317.34,148.79l2.26,4.55,39.9,79.99c1.1,2.2.26,4.91-1.86,6.04-2.12,1.14-4.73.28-5.82-1.92l-39.89-79.99-2.27-4.55c2.69-1.16,5.26-2.53,7.68-4.13Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.65,240.3c-.47,0-.94-.07-1.4-.22-1.23-.39-2.23-1.26-2.82-2.44l-42.16-84.54c-.05-.11-.06-.23-.02-.34.04-.11.13-.2.23-.25,2.68-1.15,5.24-2.53,7.61-4.09.1-.07.23-.09.35-.06.12.03.22.11.27.22l2.26,4.55,39.89,79.99c1.2,2.4.28,5.37-2.04,6.62-.69.37-1.43.56-2.19.56ZM310.24,153.13l41.95,84.13c.49.97,1.31,1.69,2.32,2.01.98.31,2.01.21,2.92-.27,1.91-1.03,2.67-3.49,1.67-5.47l-41.94-84.1c-2.17,1.4-4.5,2.65-6.92,3.72Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.55,214.86l11.26,22.58c1.1,2.2,3.71,3.06,5.83,1.92,2.12-1.14,2.95-3.85,1.85-6.05l-11.55-23.17c-2.07,2.1-4.57,3.73-7.39,4.71Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.66,240.3c-.47,0-.94-.07-1.4-.22-1.23-.39-2.24-1.26-2.83-2.45l-11.26-22.58c-.06-.11-.06-.24-.01-.36.05-.11.14-.2.26-.24,2.71-.94,5.14-2.48,7.22-4.6.1-.1.24-.14.37-.12.14.02.26.11.32.23l11.55,23.17c1.2,2.4.29,5.37-2.03,6.62-.69.37-1.43.56-2.19.56ZM341.15,215.11l11.05,22.15c.49.98,1.31,1.69,2.32,2.01.98.31,2.01.21,2.92-.28,1.91-1.03,2.66-3.48,1.67-5.48l-11.29-22.64c-1.96,1.88-4.2,3.3-6.67,4.23Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.01,193.84c.03-4.64-1.84-4.63-1.78-8.7.07-4.99.84-9.51.84-11.49,0-3.92-3.12-3.03-3.02-3.76.32-2.29.15-3.12-.33-3.92-1.15-1.91-2.95-1.46-2.58-2.3.82-1.9.56-5.4-2.51-5.13-2.07.18-3.8,1.54-5.14,3.39"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.01,194.27h0c-.24,0-.43-.2-.43-.43.02-2.3-.45-3.41-.9-4.49-.44-1.06-.9-2.15-.88-4.22.04-3,.33-5.8.56-8.04.15-1.49.28-2.66.28-3.44,0-2.4-1.2-2.72-2.07-2.95-.41-.11-1.03-.27-.94-.87.31-2.18.15-2.93-.27-3.64-.55-.92-1.27-1.22-1.8-1.44-.38-.16-.71-.29-.84-.62-.08-.19-.07-.41.03-.64.47-1.09.55-2.8-.15-3.77-.42-.58-1.06-.83-1.93-.76-2.2.19-3.84,1.85-4.83,3.21-.14.19-.41.23-.6.09-.19-.14-.23-.41-.09-.6,1.57-2.16,3.46-3.39,5.45-3.56,1.48-.13,2.28.53,2.7,1.11.91,1.27.82,3.26.26,4.59.08.05.22.1.33.15.56.23,1.51.62,2.21,1.79.52.86.72,1.73.41,4.04.08.03.2.06.29.08.88.23,2.71.72,2.71,3.78,0,.82-.12,2.01-.28,3.52-.23,2.23-.52,5-.56,7.97-.03,1.89.38,2.86.81,3.88.49,1.16.99,2.35.97,4.82,0,.24-.19.43-.43.43Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M345.6,226.8c3.48,1.29,23.24,8,32.34,9.87,20.07,4.14,22.97-.29,25.58-7.32,2.15-5.78,5.12-21.04,5.12-21.04l-26.25-12.87s-3.26,12.43-3.26,12.43l-17.33-3.85s-2.8-4.24-7.52-5.95c-7.01-2.54-12.48-.24-12.48-.24l2.3,4.6s-4.82.47-10.43-2.55c-1.62-.88-1.13,2.17.18,4.73.82,1.61,2.45,2.99,2.45,2.99,0,0-2.35,1.23-.95,4.37.85,1.9,2.74,2.98,1.6,3.44-2.87,1.15,0,8.15,8.65,11.37Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.3,207.62s-2.35,1.23-.95,4.37c.85,1.9,2.74,2.98,1.6,3.44-2.87,1.15,0,8.16,8.65,11.38.51.19,1.39.5,2.53.9-6.74-3.49-10.16-8.92-7.58-9.96,1.15-.46-.59-3.09-1.44-4.99-.55-1.24-.41-2.14-.04-2.77.51-.88.37-2.06-.34-2.79-.3-.31-.58-.67-.79-1.07-1.31-2.56-2.59-5.08-.96-4.21,3.09,1.66,6.27,2.46,8.49,2.84,1.38.23,2.5-1.15,2.05-2.53-.45-1.37.39-2.82,1.76-3.06,1.82-.32,4.49-.49,7.61.23-.79-.5-1.66-.95-2.62-1.3-7.01-2.54-12.48-.24-12.48-.24l2.29,4.6s-4.82.47-10.43-2.55c-1.63-.87-1.13,2.17.18,4.73.82,1.61,2.45,2.99,2.45,2.99Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.56,238.69c-3.26,0-7.4-.49-12.71-1.59-9.42-1.94-29.52-8.82-32.4-9.89h0c-6.21-2.31-9.97-6.86-10.01-9.92-.01-1.1.46-1.9,1.34-2.25.09-.03.11-.06.11-.06-.03-.08-.37-.5-.62-.8-.43-.53-.96-1.19-1.33-2.01-1.12-2.52-.03-3.96.66-4.58-.55-.53-1.55-1.58-2.16-2.76-.84-1.65-1.78-4.41-.9-5.27.18-.18.59-.42,1.31-.04,4.25,2.28,8.09,2.53,9.54,2.52l-2-4c-.05-.11-.06-.23-.02-.34.04-.11.13-.2.24-.25.23-.1,5.7-2.33,12.79.24,4.36,1.58,7.08,5.19,7.63,5.97l16.76,3.72q3.16-12.22,3.42-12.32c.11-.04.24-.04.34.02l26.25,12.86c.17.09.27.28.23.47-.12.62-3,15.36-5.14,21.1-1.99,5.35-4.28,9.18-13.36,9.18ZM345.75,226.4c2.87,1.07,22.9,7.92,32.27,9.86,19.47,4.01,22.47.02,25.09-7.04,1.94-5.22,4.59-18.41,5.04-20.65l-25.49-12.49c-.47,1.71-2.04,7.75-3.12,11.92-.06.23-.28.36-.51.31l-17.33-3.85c-.11-.02-.2-.09-.27-.18-.03-.04-2.78-4.14-7.31-5.78-5.65-2.05-10.32-.86-11.73-.4l2.08,4.17c.06.13.06.28,0,.4-.07.12-.19.21-.33.22-.2.02-5.02.45-10.68-2.6-.22-.12-.3-.1-.31-.1-.26.23-.05,2.07,1.08,4.26.77,1.51,2.33,2.85,2.34,2.86.11.09.16.23.15.38s-.1.27-.23.33c-.08.04-1.96,1.1-.75,3.81.32.72.81,1.33,1.21,1.82.52.64.89,1.1.76,1.6-.07.27-.27.47-.6.6-.68.27-.81.94-.81,1.44.03,2.34,2.98,6.72,9.45,9.13h0Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M285.53,52.64c27.67-2.82,52.29,18.18,55.01,46.89,1.92,20.31-7.65,39.04-23.2,49.27-2.42,1.59-4.99,2.97-7.68,4.13-4.46,1.91-9.26,3.18-14.31,3.69-27.67,2.82-52.29-18.17-55.01-46.89-2.7-28.71,17.52-54.27,45.19-57.08ZM235.44,110.21c2.98,31.51,30.01,54.56,60.38,51.47,5.69-.58,11.1-2.04,16.1-4.23,2.67-1.16,5.24-2.55,7.67-4.13,17.29-11.15,27.95-31.85,25.83-54.31-2.97-31.51-30-54.56-60.38-51.47-30.38,3.09-52.58,31.14-49.61,62.66Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.36,162.4c-12.49,0-24.56-4.33-34.48-12.47-11.97-9.83-19.38-23.92-20.87-39.67-3-31.7,19.43-60.02,49.99-63.13,14.43-1.48,28.63,2.86,40,12.2,11.96,9.83,19.37,23.91,20.85,39.66,2.08,22.05-7.89,43.01-26.02,54.71-2.48,1.61-5.08,3.01-7.73,4.16-5.14,2.25-10.61,3.69-16.23,4.26-1.84.19-3.68.28-5.51.28ZM290.51,47.7c-1.8,0-3.61.09-5.42.28-30.09,3.06-52.17,30.96-49.22,62.19,1.47,15.52,8.77,29.4,20.56,39.08,11.18,9.19,25.16,13.45,39.35,12,5.54-.57,10.91-1.98,15.97-4.2,2.61-1.13,5.17-2.51,7.61-4.09,17.86-11.52,27.69-32.18,25.64-53.91-1.46-15.52-8.76-29.4-20.54-39.08-9.76-8.02-21.64-12.28-33.94-12.28ZM290.36,157.29c-11.39,0-22.4-3.95-31.44-11.37-10.91-8.96-17.66-21.8-19.02-36.16-2.72-28.91,17.72-54.72,45.58-57.55,13.15-1.34,26.1,2.61,36.46,11.12,10.91,8.96,17.66,21.8,19.02,36.16,1.88,19.91-7.08,38.94-23.39,49.67-2.41,1.59-5.02,2.99-7.75,4.16-4.59,1.96-9.45,3.22-14.44,3.72-1.68.17-3.36.26-5.03.26ZM285.57,53.06c-27.39,2.78-47.49,28.18-44.81,56.61,1.34,14.13,7.98,26.76,18.71,35.57,10.18,8.36,22.9,12.24,35.83,10.92,4.9-.5,9.68-1.73,14.19-3.66,2.68-1.15,5.24-2.53,7.61-4.09,16.05-10.55,24.86-29.27,23.01-48.87-1.34-14.13-7.98-26.76-18.71-35.57-10.18-8.36-22.9-12.24-35.83-10.93h0ZM285.53,52.64h0,0Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.28,205.72l-3.22,9.06s-4.09,1.16-11.61-2.15c-7.51-3.3-11.44-6.02-16.19-8.06-4.31-1.86-8.32-1.21-8.63-.59-.38.76,1.01-3.75,3.07-7.8,1.39-2.74,3.57-5.01,3.85-6.28"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.02,215.42c-1.97,0-5.25-.41-9.73-2.38-4.11-1.81-7.15-3.44-9.84-4.88-2.26-1.21-4.21-2.26-6.35-3.18-4.15-1.79-7.74-1.13-8.1-.76-.02.05-.13.27-.4.29-.15.02-.3-.07-.39-.2-.34-.52,1.87-5.89,3.1-8.31.69-1.35,1.54-2.57,2.3-3.64.75-1.06,1.39-1.97,1.51-2.54.05-.23.28-.38.51-.33.23.05.38.28.33.51-.16.74-.82,1.67-1.65,2.85-.74,1.05-1.58,2.24-2.24,3.53-1.36,2.67-2.37,5.42-2.83,6.8,1.63-.48,4.88-.42,8.18.99,2.18.94,4.14,1.99,6.42,3.21,2.67,1.43,5.7,3.06,9.78,4.85,6.32,2.78,10.2,2.33,11.11,2.17l3.14-8.84c.08-.23.32-.35.55-.26.22.08.34.32.26.55l-3.22,9.06c-.05.13-.15.23-.29.27-.07.02-.81.22-2.17.22Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.26,203.47s-2.01-.31-3.93.13c-2.57.59,2.66,3.19,3.07,3.19l.86-3.32Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.4,207.22c-.46,0-4.05-1.67-4.2-2.98-.03-.3.06-.83,1.04-1.06,1.98-.45,4.01-.15,4.09-.14.12.02.23.09.29.19.07.1.09.23.06.34l-.86,3.32c-.05.19-.22.32-.42.32ZM378.62,203.8c-.65,0-1.43.05-2.19.23-.32.07-.38.16-.38.16.04.44,2.08,1.67,3.05,2.07l.63-2.41c-.28-.02-.66-.05-1.1-.05Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.7,196.99s.98-3.94.43-8.05c-.08-.63-.14-1.25-.18-1.86"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.7,197.42s-.07,0-.1-.01c-.23-.06-.37-.29-.31-.52,0-.04.95-3.91.42-7.89-.08-.61-.14-1.25-.18-1.89-.01-.24.16-.44.4-.46.23-.03.44.17.46.4.04.62.1,1.24.18,1.83.55,4.15-.4,8.05-.44,8.21-.05.2-.22.33-.42.33Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.88,177.5c-.24,0-.43-.19-.43-.43,0-5.9,2.34-11.06,5.95-13.14.21-.12.47-.05.59.16.12.21.05.47-.16.59-3.35,1.93-5.52,6.8-5.52,12.39,0,.24-.19.43-.43.43Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.58,184.21c-.21,0-.4-.16-.43-.38-.72-5.85.97-11.27,4.3-13.81.19-.14.46-.11.6.08.14.19.11.46-.08.6-3.09,2.36-4.65,7.47-3.97,13.02.03.24-.14.45-.37.48-.02,0-.04,0-.05,0Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.57,283.31c-.18,0-.34-.11-.4-.28-1.64-4.52-4.47-7.94-8.17-9.9-.21-.11-.29-.37-.18-.58.11-.21.37-.29.58-.18,3.89,2.06,6.86,5.65,8.57,10.36.08.22-.03.47-.26.55-.05.02-.1.03-.15.03Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419.03,248.89s5.6-.03,6.24,1.03c.64,1.07-5.16,3.72-5.16,3.72l-1.08-4.75Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.12,254.07c-.07,0-.13-.02-.19-.04-.12-.06-.2-.16-.23-.29l-1.08-4.75c-.03-.13,0-.26.08-.36.12-.15.3-.16.53-.16,1.56,0,5.74.11,6.42,1.24.08.14.16.37.07.67-.41,1.32-4.58,3.28-5.42,3.66-.06.03-.12.04-.18.04ZM419.57,249.32l.85,3.71c2.39-1.14,4.43-2.47,4.48-2.93-.28-.44-2.88-.75-5.32-.78Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.78,267.98c-4.86,0-8.41-2.56-10.16-4.16-2.09-1.92-3.5-4.23-3.5-5.74,0-.24.19-.43.43-.43s.43.19.43.43c0,1.07,1.11,3.16,3.22,5.1,1.79,1.64,5.55,4.32,10.69,3.89.24-.02.44.16.46.39.02.24-.16.44-.39.46-.4.03-.8.05-1.19.05Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.63,165.31c-.17,0-.33-.1-.4-.27-.09-.22.02-.47.24-.56,2.41-.94,5.27-1.33,8.76-1.19.24.01.42.21.41.45,0,.24-.22.39-.45.41-3.37-.14-6.11.24-8.41,1.13-.05.02-.1.03-.16.03Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.99,195.55c-.13,0-.27-.06-.35-.18-1.1-1.53-1.98-3.32-2.7-5.46-.08-.23.05-.47.27-.54.23-.08.47.05.54.27.69,2.06,1.54,3.77,2.59,5.23.14.19.09.46-.1.6-.08.05-.16.08-.25.08Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.07,193.22c-.27.03-.44-.19-.44-.43s.19-.43.43-.43h.01c3.36,0,6.09-.48,8.35-1.47.22-.09.47,0,.57.22.1.22,0,.47-.22.57-2.37,1.04-5.22,1.54-8.69,1.54Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.33,188.64c-.2,0-.38-.14-.42-.34-.05-.23.1-.46.33-.51,1.09-.24,2.08-.6,2.94-1.08.21-.12.47-.04.58.17.12.21.04.47-.16.59-.93.52-2,.92-3.18,1.17-.03,0-.06.01-.09.01Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.84,210.58s-.08,0-.12-.02l-10.21-3.04c-.23-.07-.36-.31-.29-.53.07-.23.31-.36.53-.29l10.21,3.04c.23.07.36.31.29.53-.06.19-.23.31-.41.31Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.4,171.34c-1.4,0-2.64-.41-3.66-1.21-1.6-1.27-2.55-3.44-2.55-5.82,0-.24.19-.43.43-.43s.43.19.43.43c0,2.09.85,4.06,2.22,5.15,1.26,1,2.89,1.27,4.83.82.23-.06.46.09.52.32.05.23-.09.46-.32.52-.66.16-1.3.23-1.9.23Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330.27,237.88c-8.73,0-11.94-6.99-12.71-9.13-.08-.22.03-.47.26-.55.23-.08.47.03.55.26.73,2.01,3.73,8.56,11.9,8.56.24,0,.43.19.43.43s-.19.43-.43.43Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.02,242.18c-1.34,0-2.64-.19-3.88-.56-.23-.07-.36-.31-.29-.53.07-.23.31-.36.53-.29,1.46.43,3.01.6,4.61.49.23-.03.44.16.46.4.02.24-.16.44-.4.46-.34.02-.69.04-1.03.04Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.11,186c-.06,0-.11-.01-.17-.03-.22-.09-.32-.34-.23-.56.82-1.97,3.05-8.87-2.84-14.76-.17-.17-.17-.44,0-.61.17-.17.44-.17.61,0,6.27,6.28,3.9,13.61,3.03,15.7-.07.17-.23.26-.4.26Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.82,186.65s-.1,0-.14-.02c-.22-.08-.34-.33-.26-.55.53-1.48.8-3.08.81-4.75,0-.24.19-.43.43-.43h0c.24,0,.43.2.43.43-.01,1.76-.3,3.46-.86,5.03-.06.18-.23.29-.41.29Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.08,331.42c-.1,0-.2-.03-.28-.1-2.74-2.33-4.93-5.23-7.06-8.04-1.09-1.43-2.21-2.92-3.39-4.3-.15-.18-.13-.45.05-.61.18-.15.45-.13.61.05,1.19,1.4,2.33,2.9,3.42,4.34,2.1,2.77,4.26,5.63,6.93,7.9.18.15.2.43.05.61-.08.1-.21.15-.33.15Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.88,165.09c-.54,0-1.03-.15-1.44-.45-.19-.14-.24-.41-.1-.6.14-.19.41-.24.6-.1.79.57,1.88.15,2.47-.14,1.73-.88,3.59-3.1,3.59-4.99,0-.24.19-.43.43-.43s.43.19.43.43c0,2.28-2.1,4.76-4.05,5.76-.68.35-1.33.52-1.92.52Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.77,177.99c-.31,0-.61-.06-.89-.18-.22-.09-.32-.35-.23-.56.09-.22.35-.32.56-.23.88.37,1.85-.27,2.35-.69,1.52-1.26,2.87-3.85,2.46-5.71-.05-.23.1-.46.33-.51.23-.05.46.1.51.33.49,2.23-1.05,5.14-2.75,6.56-.79.66-1.6,1-2.34,1Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.5,132.91c-1.01-4.85-6.93-11.55-9.6-11.88-2.67-.33-3.77,2.49.39,5.47,2.76,1.97,5.18,7.11,6.5,10.35.54,1.33,2.5,1.12,2.79-.29.2-.97.23-2.18-.08-3.66Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.12,138.18c-.77,0-1.43-.44-1.72-1.16-1.21-2.96-3.63-8.22-6.35-10.17-2.32-1.66-3.37-3.51-2.81-4.95.38-.96,1.42-1.46,2.71-1.3,2.89.35,8.93,7.24,9.97,12.22h0c.29,1.38.32,2.67.08,3.84-.17.84-.84,1.43-1.7,1.51-.06,0-.13,0-.19,0ZM385.49,121.43c-.72,0-1.26.29-1.45.79-.3.77.17,2.27,2.5,3.94,2.75,1.97,5.13,6.82,6.65,10.54.21.51.67.66,1.04.62.38-.04.82-.27.93-.83.21-1.05.19-2.22-.08-3.49h0c-1.01-4.81-6.92-11.26-9.23-11.54-.12-.02-.24-.02-.36-.02Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.19,121.63c.68-.54.77-1.55.19-2.26-.58-.71-1.6-.84-2.28-.3-.68.54-.77,1.55-.19,2.26.58.71,1.6.84,2.28.3Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.22,122.39c-.61,0-1.23-.27-1.65-.79-.36-.44-.53-.99-.47-1.55.06-.53.32-1,.73-1.32.87-.68,2.16-.52,2.88.37.36.44.53.99.46,1.55-.06.53-.32.99-.73,1.32-.36.28-.79.42-1.23.42ZM378.06,119.17c-.25,0-.49.08-.7.24-.23.18-.37.44-.41.74-.04.32.06.65.28.91.43.52,1.18.63,1.68.24h0c.23-.18.37-.44.4-.74.04-.32-.06-.65-.28-.91-.25-.31-.62-.48-.98-.48Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M467.05,113.31v30.25c0,2.66-2.08,4.82-4.64,4.82h-13.17s-18.01,12.27-18.01,12.27c-.83.56-1.91-.15-1.77-1.17l1.52-11.11h-14.89c-2.56,0-4.64-2.16-4.64-4.82v-30.25c0-2.66,2.08-4.81,4.64-4.81h46.32c2.56,0,4.64,2.16,4.64,4.81Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.59,161.27c-.28,0-.56-.08-.82-.24-.55-.34-.84-.96-.75-1.62l1.46-10.62h-14.4c-2.8,0-5.07-2.35-5.07-5.25v-30.25c0-2.89,2.27-5.24,5.07-5.24h46.32c2.8,0,5.07,2.35,5.07,5.24v30.25c0,2.89-2.27,5.25-5.07,5.25h-13.04l-17.9,12.2c-.27.18-.57.27-.87.27ZM416.08,108.92c-2.32,0-4.21,1.97-4.21,4.38v30.25c0,2.42,1.89,4.39,4.21,4.39h14.89c.12,0,.24.05.32.15.08.09.12.22.1.34l-1.52,11.11c-.05.38.15.64.35.77.24.15.52.14.75-.02l18.01-12.27c.07-.05.16-.07.24-.07h13.17c2.32,0,4.21-1.97,4.21-4.39v-30.25c0-2.42-1.89-4.38-4.21-4.38h-46.32Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M435.88,123.24c.12-.02.22-.07.3-.17.6-.71,3.33-4.02,4.47-6.72,1.29-3.05,5.37-2.86,5.37.95,0,2.54-.43,4.32-.71,5.23-.1.33.13.67.47.67,1.82-.01,6.45.22,6.81,2.88.2,1.52,0,2.18-.21,2.46-.14.18-.12.43.02.61.45.57,1.12,1.71.85,3.16-.25,1.32-.59,1.83-.81,2.04-.13.12-.18.28-.16.45.11.73.26,2.53-.8,3.68-2.14,2.32-13.75,1.96-16.24,1.86-.27-.01-.47-.24-.47-.51v-15.96c0-.26.18-.47.43-.51l.68-.1Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.32,140.83c-1.71,0-3.18-.05-4.09-.08-.5-.02-.88-.44-.88-.94v-15.96c0-.47.34-.87.79-.93l.68-.1s0,0,0,0c.01,0,.02,0,.03-.02.54-.64,3.28-3.95,4.4-6.61.71-1.68,2.28-2.63,3.84-2.32,1.14.23,2.36,1.26,2.36,3.44,0,2.64-.46,4.49-.74,5.36l.06.54v-.43c2.03-.02,6.84.28,7.24,3.25.18,1.37.09,2.27-.29,2.77.49.7,1.25,1.97.95,3.58-.21,1.13-.53,1.9-.94,2.27.1.86.26,2.82-.93,4.11-1.61,1.75-7.9,2.08-12.49,2.08ZM435.94,123.66l-.68.1s-.06.04-.06.08v15.96s.03.08.06.08c6.36.26,14.34-.03,15.91-1.72.93-1.01.79-2.66.69-3.32-.05-.31.06-.63.29-.84.1-.09.43-.48.68-1.8.24-1.28-.38-2.31-.77-2.81-.26-.34-.27-.8-.02-1.13.08-.11.33-.58.13-2.14-.32-2.36-4.96-2.5-6.38-2.51h0c-.29,0-.56-.14-.74-.37-.18-.24-.23-.56-.14-.85.26-.82.7-2.57.7-5.1,0-1.41-.62-2.38-1.67-2.6-.94-.19-2.24.3-2.88,1.81-1.17,2.78-3.99,6.18-4.54,6.83-.15.17-.35.28-.57.31Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M428.65,140.3h6.14v-16.9h-6.14c-1.08,0-1.96.91-1.96,2.03v12.83c0,1.12.88,2.03,1.96,2.03Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.65,123.4c-1.08,0-1.96.91-1.96,2.03v3.92c0-1.12.88-2.03,1.96-2.03h6.14v-3.91h-6.14Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.79,140.73h-6.14c-1.32,0-2.39-1.1-2.39-2.46v-12.83c0-1.36,1.07-2.46,2.39-2.46h6.14c.24,0,.43.19.43.43v16.89c0,.24-.19.43-.43.43ZM428.65,123.83c-.84,0-1.53.72-1.53,1.6v12.83c0,.88.69,1.6,1.53,1.6h5.71v-16.04h-5.71Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "284.86 129.31 264.3 108.5 271.21 101.68 283.22 113.83 308.17 74.72 316.36 79.94 284.86 129.31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.1,71.83c-3.86-3.62-8.67-6.25-13.77-8.02-2.56-.91-5.24-1.49-7.96-1.88-2.73-.35-5.5-.41-8.27-.24-5.53.44-11,2.05-15.86,4.69-4.86,2.64-9.18,6.14-12.68,10.27,4.45-3.08,9.01-5.81,13.8-7.87,2.42-.95,4.83-1.9,7.35-2.45,2.49-.62,5.02-1.09,7.57-1.23,5.09-.41,10.23.09,15.24,1.26,5,1.22,9.9,3.02,14.59,5.46Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M273.43,146.06c4.71,2.43,10.04,3.64,15.44,3.95,2.71.17,5.45,0,8.17-.37,2.72-.4,5.4-1.11,8.02-2.03,5.2-1.94,10.02-4.98,13.98-8.85,3.96-3.87,7.15-8.42,9.39-13.34-3.44,4.18-7.08,8.05-11.13,11.34-2.07,1.58-4.13,3.15-6.4,4.37-2.23,1.27-4.53,2.42-6.94,3.25-4.78,1.79-9.86,2.71-15,2.95-5.14.19-10.35-.2-15.52-1.27Z"
  }))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M142.43,362.99s-2.53-12.5,0-16.8c2.53-4.3,0-11.72,3.17-13.68,3.16-1.95,1.58-6.62,5.06-8.98,3.48-2.35,7.28-3.44,7.28-3.44,0,0,3.48,8.12,0,10.86-3.48,2.74-.95,8.29-3.8,10.59-2.85,2.3.34,5.43-1.57,9.33-1.91,3.91-6.66,12.11-6.66,12.11h-3.48Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.91,363.36h-3.48c-.18,0-.33-.13-.37-.3-.1-.52-2.53-12.7.04-17.07,1.14-1.93,1.21-4.52,1.28-7.03.08-2.89.16-5.63,2.01-6.77,1.42-.88,1.81-2.4,2.22-4.01.44-1.72.94-3.68,2.83-4.95,3.49-2.36,7.23-3.45,7.39-3.49.18-.05.37.04.45.21.15.34,3.55,8.42-.11,11.3-1.7,1.34-1.86,3.45-2.02,5.5-.15,1.92-.3,3.9-1.77,5.09-1.35,1.09-1.18,2.39-.96,4.03.2,1.52.44,3.25-.51,5.18-1.9,3.88-6.62,12.05-6.67,12.14-.07.12-.19.19-.32.19ZM142.74,362.62h2.96c.72-1.24,4.81-8.38,6.54-11.9.84-1.73.64-3.26.44-4.75-.23-1.72-.45-3.35,1.23-4.71,1.23-.99,1.36-2.73,1.5-4.57.16-2.11.34-4.49,2.3-6.03,2.85-2.24.59-8.62.01-10.1-.98.32-4.04,1.39-6.85,3.29-1.66,1.12-2.1,2.85-2.52,4.52-.43,1.69-.87,3.43-2.55,4.46-1.51.93-1.58,3.47-1.66,6.16-.07,2.48-.15,5.29-1.38,7.39-2.22,3.76-.37,14.32-.01,16.24Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.39,362.99s3.11-9.38,11.97-10.55c8.86-1.17,15.73-15.24,15.73-15.24,0,0-14.85-.7-18.61,4.34-3.76,5.04-13.57,21.45-13.57,21.45h4.48Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.39,363.36h-4.48c-.13,0-.26-.07-.32-.19-.07-.12-.06-.26,0-.38.1-.16,9.86-16.49,13.59-21.48,3.84-5.14,18.31-4.52,18.93-4.49.13,0,.24.07.3.18s.07.24.01.35c-.28.58-7.06,14.26-16.02,15.44-8.52,1.13-11.64,10.21-11.67,10.3-.05.15-.19.26-.35.26ZM146.56,362.62h3.56c.59-1.53,4.03-9.47,12.18-10.55,7.6-1.01,13.83-11.98,15.18-14.51-2.77-.06-14.53-.06-17.71,4.21-3.31,4.44-11.45,17.92-13.21,20.85Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.42,362.99s-.32-17.65-5.06-25.82c-4.75-8.17-5.28-5.05-8.02-5.83-2.74-.78-4.01-4.69-6.85-3.91l-2.85.78s3.8,3.13,3.8,5.47-1.9,5.64,1.58,7.51c3.48,1.87,1.85,5.58,4.32,7.97,5.8,5.62,8.02,13.04,8.02,13.82s5.06,0,5.06,0Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.78,363.71c-.73,0-1.34-.08-1.59-.29-.13-.11-.2-.26-.2-.43,0-.48-2-7.84-7.9-13.56-1.18-1.14-1.48-2.53-1.78-3.87-.35-1.58-.68-3.08-2.46-4.04-2.84-1.53-2.39-4-2.02-5.99.12-.66.24-1.29.24-1.85,0-2.14-3.63-5.15-3.66-5.18-.11-.09-.16-.23-.13-.37s.13-.24.27-.28l2.85-.78c1.85-.5,3.1.73,4.3,1.92.83.83,1.69,1.68,2.76,1.98.65.18,1.16.13,1.66.07,1.83-.2,3.12-.02,6.57,5.93,4.74,8.16,5.1,25.28,5.11,26,0,.19-.13.35-.32.38-.86.13-2.46.35-3.7.35ZM137.72,362.88c.46.19,2.49.06,4.32-.21-.07-2.44-.71-17.93-5-25.31-3.39-5.83-4.47-5.71-5.85-5.56-.55.06-1.17.13-1.95-.1-1.25-.36-2.18-1.28-3.08-2.17-1.15-1.14-2.14-2.13-3.57-1.73l-2.18.6c1.08.98,3.4,3.34,3.4,5.29,0,.63-.12,1.28-.25,1.98-.37,2.02-.73,3.92,1.64,5.19,2.09,1.12,2.47,2.86,2.84,4.54.28,1.29.55,2.51,1.57,3.5,5.69,5.51,7.98,12.67,8.12,13.98Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M137.36,362.99s.84-2.72-4.17-9.17c-5.01-6.46-15.14-4.65-15.14-4.65,0,0,8.96,4.06,11.29,8.35,2.32,4.3,1.69,5.82,1.69,5.82l6.33-.35Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.03,363.71c-.12,0-.23-.06-.3-.16-.07-.1-.09-.24-.04-.36,0,0,.49-1.49-1.67-5.5-2.23-4.14-11.02-8.15-11.11-8.19-.15-.07-.24-.22-.22-.39.02-.16.14-.29.3-.32.42-.07,10.41-1.77,15.5,4.79,5.07,6.54,4.27,9.39,4.23,9.51-.05.15-.18.25-.34.26l-6.33.35s-.01,0-.02,0ZM137.36,362.99h0,0ZM137.36,362.99h0,0ZM119.38,349.39c2.54,1.27,8.42,4.5,10.29,7.96,1.67,3.08,1.86,4.8,1.81,5.6l5.55-.3c.04-.79-.18-3.49-4.13-8.59-3.78-4.88-10.69-4.88-13.52-4.66Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.78,385.53c3.18-2.2,5.27-5.94,5.27-10.2v-12.26h-23.62v12.26c0,4.26,2.09,8,5.27,10.2h13.08Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.22,378.21v-12.26h20.83v-2.88h-23.62v12.26c0,4.13,1.97,7.77,4.99,9.99-1.38-2-2.19-4.46-2.19-7.11Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.78,385.91h-13.08c-.08,0-.15-.02-.21-.07-3.4-2.35-5.43-6.28-5.43-10.51v-12.26c0-.21.17-.37.37-.37h23.62c.21,0,.37.17.37.37v12.26c0,4.23-2.03,8.15-5.43,10.51-.06.04-.14.07-.21.07ZM134.82,385.16h12.85c3.14-2.22,5.01-5.89,5.01-9.83v-11.88h-22.87v11.88c0,3.94,1.87,7.61,5.01,9.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceOfficers);
export default __webpack_public_path__ + "static/media/compliance-officers.98be88fe2976dfadabc94399935dbbbf.svg";
export { ForwardRef as ReactComponent };